import { createStructuredSelector } from 'reselect';
import { userIdSelector } from 'swag-client-common/redux/user/user.selectors';
import { pageSelector, lastPageSelector, isLoadingSelector, isProductsListFetchedSelector, searchResultsSelector, errorSelector } from '../../../../../../../redux/search-results/search-results.selectors';
import { subcategoriesSelector } from '../../../../../../../redux/product-listing/product-listing.selectors';
export const infiniteProductsSelector = createStructuredSelector({
  page: pageSelector,
  lastPage: lastPageSelector,
  isLoading: isLoadingSelector,
  isProductsListFetched: isProductsListFetchedSelector,
  subcategories: subcategoriesSelector,
  products: searchResultsSelector,
  isLoggedIn: userIdSelector,
  error: errorSelector
});